import { Prescripteur, useSociete, useTiersService } from '@europrocurement/l2d-domain';
import usePromises from '@europrocurement/l2d-hooks/hooks/usePromises';
import { useCallback, useState } from 'react';

const useExistingsPrescribers = (prescriberSiret: string | undefined) => {
    const [currentSiret, setCurrentSiret] = useState<string | undefined>(prescriberSiret);

    const xIdSociete = useSociete();
    const { prescribersApi } = useTiersService();

    const {
        isFetching: prescribersLoading,
        fetchedData: existingPrescribers,
        isLoaded: prescribersLoaded,
        call,
    } = usePromises();

    const fetchPrescribersFromSiret = useCallback(
        (siret: string) => {
            const elasticSearchParameters = `{"query":{"bool":{"must":[{"match":{"relationsSocietes.societe.id":${xIdSociete}}},{"match":{"isPrescripteur":true}},{"match":{"demo":false}},{"match":{"deleted":false}},{"query_string":{"query":"siret:*${siret}*"}}]}}}`;
            return prescribersApi.getListTiersTiersCollection({
                xIdSociete,
                search: elasticSearchParameters,
            });
        },
        [xIdSociete, prescribersApi],
    );

    const getExistingPrescribers = useCallback(
        (siret: string | undefined = undefined) => {
            if (siret && siret !== currentSiret) {
                setCurrentSiret(siret);
            }
            if (
                (siret || currentSiret) &&
                xIdSociete &&
                !prescribersLoading &&
                !prescribersLoaded
            ) {
                call([
                    {
                        name: 'fetchPrescribersFromSiret',
                        promise: fetchPrescribersFromSiret((siret || currentSiret) as string),
                    },
                ]);
            }
        },
        [
            currentSiret,
            xIdSociete,
            prescribersLoading,
            prescribersLoaded,
            call,
            fetchPrescribersFromSiret,
        ],
    );

    const prescribersRelatedToSiret: Prescripteur[] | undefined =
        existingPrescribers?.fetchPrescribersFromSiret;

    return {
        prescribersRelatedToSiret,
        getExistingPrescribers,
        prescribersLoading,
        prescribersLoaded,
    };
};

export default useExistingsPrescribers;
